/**
 * getQueryParameterByName
 *
 * @param {string} name of query parameter from url
 * @param {string} url optional, if not provided current url will be used
 * @returns {string} value of given query parameter
 */
export const getQueryParameterByName = (name, url?) => {
    if (!url) url = window.location.href
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    const param = decodeURIComponent(results[2].replace(/\+/g, ' '))
    return param
}
